import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/position-levels',
    name: 'position-level',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/position-level/index.vue')
  }
]
